import React             from 'react';
import classNames        from 'classnames';
import {
  WithStyle,
  IActionMenuItem,
  ActionMenu
}                        from 'rewire-ui';
import {
  PopoverOrigin
}                        from '@material-ui/core/Popover';
import { ButtonProps }   from '@material-ui/core/Button';
import { Theme }         from '@material-ui/core/styles';
import Typography        from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles }    from '../utility/styles';

interface IMenuButtonProps {
  text:     string;
  items:    IActionMenuItem[];
  disabled: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  button: {
    display: 'flex',
    position: 'relative',
    minWidth: '100px',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.dialogPrimary.main,
    marginLeft: '5px',
    '&:hover': {
      backgroundColor: theme.palette.dialogPrimary.light,
    },
  },
  buttonInnerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  text: {
    align: 'left',
    display: 'inline',
  },
  textWithIcon: {
    paddingRight: '24px',
  },
  icon: {
    fontSize: '2rem',
    position: 'absolute',
    top: 0,
    right: '6px',
  },
  label: {
    paddingTop: '6px',
    paddingBottom: '5px',
  }
});

type MenuButtonProps = WithStyle<ReturnType<typeof styles>, IMenuButtonProps>;

class MenuButton extends React.PureComponent<MenuButtonProps> {
  constructor(props: MenuButtonProps) {
    super(props);
  }

  render() {
    const { classes, text, items, disabled } = this.props;

    if (disabled) {
      items.forEach((i: IActionMenuItem) => i.disabled = () => true);
    }

    const buttonContent =
      <div className={classes.buttonInnerContainer}>
        <Typography variant='body2' className={classNames(classes.text, items.length ? classes.textWithIcon : undefined)}>{text}</Typography> {items.length ? <ArrowDropDownIcon className={classes.icon} /> : null}
      </div>;

    const buttonProps:     ButtonProps   = { color: 'primary',   variant: 'contained', disabled };
    const anchorOrigin:    PopoverOrigin = { vertical: 'bottom', horizontal: 'right' };
    const transformOrigin: PopoverOrigin = { vertical: 'top',    horizontal: 'right' };

    return (
      <ActionMenu
        menuId='menu-button'
        items={items}
        buttonContent={buttonContent}
        buttonProps={buttonProps}
        getContentAnchorEl={null}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        classes={{ menuButton: classes.button }}
      />
    );
  }
}

export default withStyles<IMenuButtonProps>(styles, MenuButton);
